// Condensed standard terms of the LED Digital Billboard Advertising
// Contract. The full 45-section contract ran to ~11 PDF pages; these key
// terms keep only the clauses that matter legally and commercially
// (payment, cancellation, content, liability, law) so the exported
// contract fits on two A4 pages. The per-contract parts (parties,
// campaign details, pricing, signatures) are built from the contract's
// data in generateContractPdf.js.
export const KEY_TERMS = [
  {
    title: 'Purpose',
    text: "CloudScreen shall display the Advertiser's promotional content on its LED digital screen(s) according to the package, schedule, duration and location stated in this Agreement.",
  },
  {
    title: 'Duration & Rotation',
    text: 'Unless otherwise agreed, each advertisement may run up to 20 seconds per playback within a rotating playlist. Exact playback times may vary slightly, and no specific number of impressions, viewers, sales or leads is guaranteed unless stated in writing.',
  },
  {
    title: 'Material & Deadline',
    text: "The Advertiser shall supply final material (MP4, MOV, JPG, PNG or another approved format) suited to the screen's resolution at least 24–48 hours before the start date. Late submission may delay the campaign; the end date is not automatically extended.",
  },
  {
    title: 'Content Approval & Responsibility',
    text: 'CloudScreen may reject or remove content that is illegal, misleading, offensive, infringes intellectual property, or is unsuitable for the public or venue. The Advertiser warrants it holds all rights to its material and is solely responsible for its claims, prices and details. Approval of a proof by the Advertiser constitutes approval for publication.',
  },
  {
    title: 'Payment & Taxes',
    text: '100% payment is required before campaign commencement unless otherwise agreed in writing. If payment is overdue, CloudScreen may suspend or remove the campaign until outstanding amounts are paid. Prices are subject to applicable VAT and taxes under Thai law.',
  },
  {
    title: 'Cancellation & Changes',
    text: 'Cancellations and change requests must be made in writing. Production, design and booking costs are non-refundable, and once the campaign has started the advertising fee is generally non-refundable. Changes are subject to availability and may incur charges. Bookings may not be transferred without written approval.',
  },
  {
    title: 'Interruptions & Make-Good',
    text: 'CloudScreen will use reasonable efforts to keep the screen operational. Temporary interruptions (power, network, hardware, maintenance, weather, authority or venue requirements, emergency messages) may occur. For a significant interruption materially affecting the campaign, CloudScreen may extend the campaign or provide replacement airtime; minor interruptions are not compensated.',
  },
  {
    title: 'Force Majeure & Location',
    text: 'Neither Party is liable for failure or delay caused by events beyond its reasonable control. If the screen location becomes unavailable, CloudScreen may provide an alternative screen or location where reasonably available.',
  },
  {
    title: 'No Guarantee & Non-Exclusivity',
    text: 'LED advertising is a marketing service; CloudScreen does not guarantee sales, visits, leads or any commercial result. Placement is non-exclusive unless an exclusive package is purchased, and competitors may advertise on the same screen.',
  },
  {
    title: 'Indemnity & Liability',
    text: "The Advertiser shall indemnify CloudScreen against claims arising from the Advertiser's content, products or services (including copyright, trademark and misleading claims). To the extent permitted by law, CloudScreen is not liable for indirect or consequential losses, and its liability is limited to the amount paid for the affected campaign.",
  },
  {
    title: 'Confidentiality & Data',
    text: "Both Parties shall keep the other's non-public business information confidential and handle personal data in accordance with applicable privacy laws.",
  },
  {
    title: 'Termination & Renewal',
    text: "CloudScreen may suspend or terminate the campaign for overdue payment, prohibited content, material breach, or legal or safety risk. The Advertiser may terminate if CloudScreen fails to remedy a material breach after written notice. Termination does not create a refund right for services already provided. Campaigns do not renew automatically.",
  },
  {
    title: 'Governing Law & Entire Agreement',
    text: 'This Agreement is governed by the laws of the Kingdom of Thailand; disputes shall first be settled by good-faith negotiation, then by the competent Thai courts. This Agreement, with the accepted quotation, invoice and booking confirmation, forms the entire agreement. An invalid provision does not affect the rest.',
  },
  {
    title: 'Acknowledgement',
    text: 'By signing, the Advertiser confirms it has read and accepts these terms, has provided accurate information, owns or is licensed to use all advertising material, and understands that advertising results are not guaranteed.',
  },
];

// Default reference time-slot pricing shown in Section 5 - kept in sync
// with backend ContractService.DEFAULT_PRICING_TABLE; a new contract starts
// with this and the admin can edit/add/remove rows before saving.
export const DEFAULT_PRICING_TABLE = [
  { timeSlot: '3:00 PM – 5:00 PM', price: 12000 },
  { timeSlot: '5:00 PM – 10:00 PM', price: 20000 },
  { timeSlot: '10:00 PM – 2:00 AM', price: 15000 },
];
